import { faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface IErrorBoundaryProps {
    errorRender?: React.ReactNode;
    errorText?: string;
    showTryAgain?: boolean;
}
interface IErrorBoundaryStates {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<
    IErrorBoundaryProps,
    IErrorBoundaryStates
> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return (
                <div className="d-flex flex-column align-items-center g-1 w-100 p-10">
                    {this.props.errorRender ?? (
                        <div className="text-muted text-center">
                            {this.props.errorText ??
                                "Tivemos um problema ao tentar carregar a página :("}
                        </div>
                    )}
                    {this.props.showTryAgain !== false && (
                        <small
                            className="btn-link text-center d-flex g-1 align-items-center justify-content-center"
                            role="button"
                            onClick={() => {
                                this.setState({ hasError: false });
                            }}
                        >
                            Tentar novamente{" "}
                            <FontAwesomeIcon icon={faUndoAlt} />
                        </small>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}
